<template>
    <div>
     <navbar :title="fad" :box="box"/>
      <van-button style="margin-top:25px" v-if="donemvar === 0"  @click="havuzAc()"  type="danger" size="large" block>Havuz Dönemi Aç</van-button>
      <van-button style="margin-top:25px" v-if="donemvar === 1" @click="liste()"  type="primary" size="large" block>Havuz Güncelle</van-button>
      <van-divider>Ödeme Talepleri</van-divider>
      <div style="margin-bottom:75px" v-for="(item,index) in talepler" :key="index">
      <van-panel v-if="talepler.length > 0" @click="odemeyap(item.id,item.odenecek)" :title="item.uye_kod" :desc="trtgoster(item.logu)" :status="parabirimi(item.odenecek)"/>
      </div>
        <van-button @click="cikis" style="margin-top:15px" type="danger" size="large">Güvenli Çıkış</van-button>
      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import navbar from './nav'
import {Toast} from 'vant'

export default {
components:{
  navbar
},
  data() {
    return {
      talepler:[],
      activeTabs:0,
      loading:false,
      show:false,
      active:'Cüzdan',
      cuzdan:[],
      anlik:{
        daralma:helper.funcs.parabirimi(0),
        qvpuani:helper.funcs.parabirimi(0),
        qvbonus:helper.funcs.parabirimi(0),
        toplam:helper.funcs.parabirimi(0)
      },
      kay:parseInt(helper.settings.ayar().ay),
      kyil:parseInt(helper.settings.ayar().yil),
      aay:parseInt(helper.settings.donem().ay),
      ayil:parseInt(helper.settings.donem().yil),
      donemler:[],
      fad:"Havuz",
      ref_kod:helper.settings.ayar().referans,
      uye_kod:helper.settings.ayar().uye,
      uye_ad:helper.settings.ayar().uye_ad,
      parola:helper.settings.ayar().pass,
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
      obje:{},
      obje2:[],
      derinlik:0,
      anakol:0,
      toplamuye:0,
      toplamsayac:0,
      havuz:[
        {havuz:1,kisi:0,tcv:0,anaoran:0,ay:parseInt(helper.settings.donem().ay),yil:parseInt(helper.settings.donem().yil)}, // index 0
        {havuz:3,kisi:0,tcv:0,anaoran:3,ay:parseInt(helper.settings.donem().ay),yil:parseInt(helper.settings.donem().yil)},
        {havuz:5,kisi:0,tcv:0,anaoran:5,ay:parseInt(helper.settings.donem().ay),yil:parseInt(helper.settings.donem().yil)},
        {havuz:6,kisi:0,tcv:0,anaoran:6,ay:parseInt(helper.settings.donem().ay),yil:parseInt(helper.settings.donem().yil)} //index 3
      ],
      tcv:0,
      donemvar:0
    };
  },
  computed: {}, 
created (){

  this.show = true
  this.odeme_talepleri()
  helper.request.get('tcv/'+this.aay+'/'+this.ayil)
  .then(res=> {
    this.tcv = res.tcv
    helper.request.get('havuza_bak/'+this.aay+'/'+this.ayil)
      .then(res=> {
          if (res.results.length === 0 ){this.donemvar = 0 ; this.show = false}
          else{
            this.donemvar = 1
            this.show = false
          }
      })
    })
  //this.havuzKontrol()
},
methods:{
havuzAc(){
  this.show = true
                       this.havuz.forEach((element,i) => {
                         let data = {
                           havuz : element.havuz,
                           kisi : element.kisi,
                           tcv:0,
                           ay:element.ay,
                           yil:element.yil,
                           anaoran:element.anaoran
                         }
                         helper.request.post('havuz_ac',data)
                          .then(() => {
                            if (i === 3) {setTimeout(() => {Toast("Havuz Açıldı"); this.donemvar =1 ; this.show = false}, 1000);}
                          })
                       });
      },

liste(){
helper.request.get("liste/") 
.then(res => {
this.show = true
this.aktifdonem(res.results)
})
},
aktifdonem(list){
  let pros=0
  list.forEach(element => {
    Object.assign(this.obje,{[element.uye_kod]: []})
    helper.request.get("cuzdan/"+element.uye_kod+"/"+this.aay+"/"+this.ayil)
    .then(res => {
     // setTimeout(() => {
        //console.log(pros)
        //pros++
        if(res.results.length > 0) this.toplamuye++
        this.hobbala(res.results,this.aay,this.ayil,0,element.uye_kod)
        //if (78 === pros) {console.log(this.obje)}
      //}, 1000);
      
      })
        

  });
  // let kodu = '1157950446'
  // let data = {name:1,sur:2}
  //     this.obje[kodu].push(data)
  //     console.log(this.obje)

},

    hobbala(arg,ay,yil,anakol,anakod){
      var pross = 0
      for (let i = 0, p = Promise.resolve(); i < arg.length; i++) {
        p = p.then(_ => new Promise(resolve => {
          
          //setTimeout(() => {
          anakol++
          this.derinlik = 1
          let data = {
          kod:arg[i].uye_kod,
          derinlik : this.derinlik,
          anakol:anakol,
          qv:arg[i].puan,
          ay:ay,
          yil:yil
          }
          //console.log(data)
          this.obje[anakod].push(data)
          this.kol(data.kod,data.derinlik,anakol,ay,yil,anakod)
            .then(res => {
              pross++
              if(arg.length === pross){
                setTimeout(() => {
                //console.log(this.obje)
                this.grupla(this.obje[anakod],ay,yil,anakod)
                  .then(response=> { 
                  //console.log(response)
                    this.havuz_kol_kontrol(response[anakod],anakod)
                     .then(resp => {
                       this.havuz.forEach((element,i) => {
                         let data = {
                           havuz : element.havuz,
                           kisi : element.kisi,
                           tcv:this.tcv,
                           ay:element.ay,
                           yil:element.yil
                         }
                         helper.request.post('havuz_guncelle',data)
                          .then(() => {
                            if (i === 3) {Toast('Havuz güncellendi');  this.show = false}
                          })
                          
                       });
                       
                     })
                })
              }, 3000);
              }
              resolve()
            })
           }
        ))
      }
    },
    kol(kod,derinlik,anakol,ay,yil,anakod){
      return new Promise ((resolve,reject)=>{
        helper.request.get("cuzdan/"+kod+"/"+ay+"/"+yil)
        .then(res => {
          if (res.results.length===0){resolve(true)}
           else{
             derinlik++
              this.getProduct(res.results,derinlik,anakol,ay,yil,anakod)
               .then(res=>{
                 this.getProduct2().then(response => {
                   //setTimeout(() => {
                     resolve()
                   //},1000 );
                   
                 })
             })
            }
        })
      })
    },
    getProduct2(){
      return new Promise ((resolve,reject)=>{
        var pros = 0
        this.obje2.forEach((element) => { 
            this.kol(element.kod,element.derinlik,element.anakol,element.ay,element.yil,element.anakod)
            pros++
        });
        if (pros === this.obje2.length) resolve()
      })
    },
    getProduct(arg,derinlik,anakol,ay,yil,anakod){ // sabit arttıcı
    return new Promise ((resolve,reject)=>{
    this.obje2 = []
      var pros = 0
          arg.forEach((element,i) => {
              let data = {
                 kod:element.uye_kod,
                 derinlik : derinlik,
                 anakol:anakol,
                 qv:element.puan,
                 ay:ay,
                 yil:yil,
                 anakod:anakod
               }
          this.obje[anakod].push(data)
          this.obje2.push(data)
          pros++
          });

        //  },500);
          if(arg.length === pros){
            resolve(true)
          }
      })
    },
    grupla(arr,ay,yil,anakod){
        return new Promise ((resolve,reject) => {
          helper.request.get("derinlik/"+ay+"/"+yil)
          .then(res => {
            var result = [] 
            arr.forEach(function (a) {
              if ( !this[a.anakol] ) {
                  this[a.anakol] = { anakol: a.anakol,kod:a.kod,qv:0,pv:0};
                    result.push(this[a.anakol]);
              }
              this[a.anakol].qv +=a.qv;
              if (a.derinlik<=res.pvd)
              {
               // derinliklerin kendi içindeki alışverilerinin toplam hesaplaması bireysel olarak
                this[a.anakol].pv +=(res[a.derinlik] * a.qv)/100;
              }
            }, Object.create(null));
            resolve({[anakod]:result})
           // resolve({[anakod]:result,cv:res.cv,qv:res.qv,pv:res.pv,aktiflik:res.aktiflik})

            })
        }) 
    },
    havuz_kol_kontrol(obj,anakod){
      return new Promise((resolve,reject) => {
        
        let pross = 0
        let toplamkol = obj.length
       // let toplampv = 0

        let dort_k6 = 0 // 400000
        let dort_k5 = 0 // 250000
        let dort_k4 = 0 // 130000
        let dort_k3 = 0 // 90000
        let dort_k2 = 0 // 50000
        let dort_k1 = 0 // 20000
        let uc_k2 = 0 // 10000
        let uc_k1 = 0 // 25000
        let iki_k4 = 0 // 4000
        let iki_k3 = 0 // 2500
        let iki_k2 = 0 // 1000
        let iki_k1 = 0 // 100
        obj.forEach(arg => {
         //toplampv += arg.pv
            if (arg.qv>=100) iki_k1++ //havuz 1 lik
            if (arg.qv>=1000) iki_k2++ //havuz 3 lük
            if (arg.qv>=2500) iki_k3++ //havuz 3 lük
            if (arg.qv>=4000) iki_k4++ //havuz 3 lük
            // ikilik sistem
            if (arg.qv>=10000)  uc_k1++ //havuz 5 lik
            if (arg.qv>=25000)  uc_k2++ //havuz 5 lik
            //üçlük sistem bitiş

            if (arg.qv>=20000 )  dort_k1++ //havuz 6 lık
            if (arg.qv>=50000) dort_k2++ //havuz 6 lık
            if (arg.qv>=90000)  dort_k3++ //havuz 6 lık
            if (arg.qv>=130000) dort_k4++ //havuz 6 lık
            if (arg.qv>=250000)  dort_k5++ //havuz 6 lık
            if (arg.qv>=400000) dort_k6++ //havuz 6 lık
          pross++
        });

          if(pross = toplamkol){
            
              if(dort_k6 >= 4) {this.havuz[3].kisi++} //dört_k6
                else if(dort_k5 >= 4) {this.havuz[3].kisi++} //dört_k5
                  else if(dort_k4 >= 4) {this.havuz[3].kisi++} //dört_k4
                    else if(dort_k3 >= 4) {this.havuz[3].kisi++} //dört_k3
                      else if(dort_k2 >= 4) {this.havuz[3].kisi++} //dört_k2
                        else if(dort_k1 >= 4) {this.havuz[3].kisi++} //dört_k1
                          else if(uc_k2 >= 3) {this.havuz[2].kisi++}// üç_k2
                            else if(uc_k1 >= 3) {this.havuz[2].kisi++}// üç_k1
                              else if(iki_k4 >= 2) {this.havuz[1].kisi++}// iki_k4
                                else if(iki_k3 >= 2) {this.havuz[1].kisi++}// iki_k3
                                  else if(iki_k2 >= 2) {this.havuz[1].kisi++}// iki_k2
                                    else if(iki_k1 >= 2) {this.havuz[0].kisi++}// iki_1
             this.toplamsayac++

          }
         if (this.toplamuye === this.toplamsayac){resolve()}
      })

   },

       odeme_talepleri(){
      helper.request.get('odeme_talepleri')
       .then(res=>{
         console.log(res)
         if (status){
         this.talepler = res
         this.show = false
         }

       })
    },
    odemeyap(id,odeme){
        Dialog.confirm({
        title: 'Onaylıyor musunuz ?',
        message:'Ödeme Yapılacak',
        }).then(() => {
          helper.request.post('odeme', {id:id,odenen:odeme})
          .then(()=>{
            Toast("İşlem Başarılı")
            this.odeme_talepleri()
          })
        })
    },
    trtgoster(uzuntarih){
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
      const d = new Date(uzuntarih);
      return d.getDate() +'-'+ monthNames[d.getMonth()]+'-'+d.getFullYear();
    },
    parabirimi(res){
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
    },
      cikis(){
        this.show = true
        userService.logout();
      },    
}
};
</script>
<style>
van-circle{background:white}
</style>


// WEBPACK FOOTER //
// src/components/havuz.vue